import Glide from '@glidejs/glide';

export default class RealEstateGroupsCarousel {
  constructor(_container) {
    this._container = _container;
    this._slider = this._container.querySelector('.glide');
    this._sliderConfiguration = {
      type: 'slider',
      perView: 3,
      gap: 40,
      breakpoints: {
        800: {
          perView: 2
        },
        544: {
          perView: 1,
          gap: 20
        }
      }
    }
    this._initialize()

  }

  _initialize() {
    const glide = new Glide(this._slider, this._sliderConfiguration);
    glide.mount();
  }


}
